import { Dispatcher } from 'flux';

class AdminDispatcher extends Dispatcher<{}> {
  constructor() {
    super();
    this.handleUpdateAdmins = this.handleUpdateAdmins.bind(this);
  }

  handleUpdateAdmins(admins: string[]) {
    this.dispatch({
      source: 'UPDATE_ADMINS',
      output: admins,
    });
  }
}

const instance = new AdminDispatcher();
export default instance;



// WEBPACK FOOTER //
// ./src/dispatchers/AdminDispatcher.ts